const relacaoTipoPergunta = (tipo) => ({
  tradicional: tipo === 'tradicional',
  sim_nao_livre: tipo === 'sim_nao_livre',
  checkbox: tipo === 'checkbox',
})

const tipoCampoLivre = (tipo) => ({
  numero: tipo === 'numero',
  porcentagem: tipo === 'porcentagem',
  data_hora: tipo === 'data_hora',
  livre: tipo === 'livre',
})

const tipoEnvioEvidencia = (tipo) => ({
  pergunta: tipo === 'pergunta',
  alternativas: tipo === 'alternativas',
})

export { relacaoTipoPergunta, tipoCampoLivre, tipoEnvioEvidencia }
